import { render, staticRenderFns } from "./ProcessModelForm.vue?vue&type=template&id=bb04fc44&"
import script from "./ProcessModelForm.vue?vue&type=script&lang=js&"
export * from "./ProcessModelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports